import { useQuery } from '@tanstack/react-query';
import type { MembershipRole } from '@katsquare/types';
import { listWorkspaces } from '../../lib/api';

/** The current user's role in a workspace (from the cached workspace list). */
export function useWorkspaceRole(workspaceId?: string): MembershipRole | undefined {
  const { data } = useQuery({ queryKey: ['workspaces'], queryFn: listWorkspaces });
  return workspaceId ? data?.find((w) => w.id === workspaceId)?.role : undefined;
}

/** Reviewers can comment/approve but not create or edit content. */
export function useCanEdit(workspaceId?: string): boolean {
  const role = useWorkspaceRole(workspaceId);
  return role !== undefined && role !== 'REVIEWER';
}
